// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shoplist-page {
  padding: 40px 160px 80px;
  min-height: 50vh;
}

.shoplist-title {
  font-size: 28px;
  font-weight: 600;
  color: #2e2e2e;
  margin: 0 0 32px;
}

.shoplist-empty {
  text-align: center;
  padding: 80px 0;
  color: #909090;
}

.shoplist-empty-btn {
  display: inline-block;
  margin-top: 16px;
  background: #2e2e2e;
  color: white;
  padding: 12px 32px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
}

.shoplist-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.shoplist-item {
  display: flex;
  align-items: center;
  gap: 24px;
  background: #f5f5f5;
  border-radius: 9px;
  padding: 16px 24px;
}

.shoplist-item-image {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.shoplist-item-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.shoplist-item-info {
  flex: 1 1;
  min-width: 0;
}

.shoplist-item-name {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  margin: 0 0 4px;
}

.shoplist-item-price {
  font-size: 18px;
  font-weight: 600;
  color: #000;
  margin: 0;
}

.shoplist-item-actions {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.shoplist-continue-btn {
  background: #2e2e2e;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

.shoplist-remove-btn {
  background: transparent;
  border: 1px solid #d4d4d4;
  color: #6c6c6c;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}

.shoplist-total {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  align-items: baseline;
  padding-top: 24px;
  font-size: 16px;
  color: #6c6c6c;
}

.shoplist-total strong {
  font-size: 24px;
  color: #000;
}

@media (max-width: 900px) {
  .shoplist-page {
    padding: 24px 24px 56px;
  }

  .shoplist-item {
    flex-wrap: wrap;
  }

  .shoplist-item-actions {
    width: 100%;
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShopList.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF","sourcesContent":[".shoplist-page {\n  padding: 40px 160px 80px;\n  min-height: 50vh;\n}\n\n.shoplist-title {\n  font-size: 28px;\n  font-weight: 600;\n  color: #2e2e2e;\n  margin: 0 0 32px;\n}\n\n.shoplist-empty {\n  text-align: center;\n  padding: 80px 0;\n  color: #909090;\n}\n\n.shoplist-empty-btn {\n  display: inline-block;\n  margin-top: 16px;\n  background: #2e2e2e;\n  color: white;\n  padding: 12px 32px;\n  border-radius: 8px;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.shoplist-items {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.shoplist-item {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  background: #f5f5f5;\n  border-radius: 9px;\n  padding: 16px 24px;\n}\n\n.shoplist-item-image {\n  width: 80px;\n  height: 80px;\n  flex-shrink: 0;\n  background: white;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.shoplist-item-image img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.shoplist-item-info {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.shoplist-item-name {\n  font-size: 16px;\n  font-weight: 500;\n  color: #000;\n  margin: 0 0 4px;\n}\n\n.shoplist-item-price {\n  font-size: 18px;\n  font-weight: 600;\n  color: #000;\n  margin: 0;\n}\n\n.shoplist-item-actions {\n  display: flex;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.shoplist-continue-btn {\n  background: #2e2e2e;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.shoplist-remove-btn {\n  background: transparent;\n  border: 1px solid #d4d4d4;\n  color: #6c6c6c;\n  border-radius: 8px;\n  padding: 10px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.shoplist-total {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  align-items: baseline;\n  padding-top: 24px;\n  font-size: 16px;\n  color: #6c6c6c;\n}\n\n.shoplist-total strong {\n  font-size: 24px;\n  color: #000;\n}\n\n@media (max-width: 900px) {\n  .shoplist-page {\n    padding: 24px 24px 56px;\n  }\n\n  .shoplist-item {\n    flex-wrap: wrap;\n  }\n\n  .shoplist-item-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
